import React from 'react';
import Button from './Buttons';
import './Tabs.css';

interface TabProps {
  label: string;
  value: string;
  children: React.ReactNode;
}

interface TabsProps {
  children: React.ReactElement<TabProps> | React.ReactElement<TabProps>[];
  activeTab: string;
  onTabChange: (value: string) => void;
}

export function Tabs({ children, activeTab, onTabChange }: TabsProps) {
  return (
    <div className="w-100">
      <div className="tabs mb-3">
        {React.Children.map(children, (child) => {
          if (!React.isValidElement<TabProps>(child)) return null;
          return (
            <Button
              className="tab-button"
              variant={child.props.value === activeTab ? 'primary' : 'secondary'}
              size="medium"
              onClick={() => onTabChange(child.props.value)}
            >
              {child.props.label}
            </Button>
          );
        })}
      </div>
      <div className="tab-content d-flex w-100">
        {React.Children.map(children, (child) => {
          if (!React.isValidElement<TabProps>(child)) return null;
          return child.props.value === activeTab ? child : null;
        })}
      </div>
    </div>
  );
}

export function Tab({ children }: TabProps) {
  return <div className="d-flex wrap-text w-100">{children}</div>;
}
